export type DocumentLogoSource = 'none' | 'organization' | 'client' | 'both';

export interface Document {
  id: string;
  organizationId: string;
  clientId: string;
  projectId?: string;
  templateType: DocumentTemplateType;
  title: string;
  description?: string;
  status: DocumentStatus;
  tags: string[];
  version: number;
  content: string;
  dynamicFields: { [key: string]: any };
  signatures: DocumentSignature[];
  metadata: DocumentMetadata;
  viewedBy: DocumentViewer[];
  signingToken?: string;
  signingTokenExpiresAt?: Date;
  signingTokenUsed?: boolean;
  publicSigningEnabled?: boolean;
  logoSource?: DocumentLogoSource;
  orgLogoUrl?: string;
  clientLogoUrl?: string;
  signedPdfUrl?: string;
  pdfUrl?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface DocumentTemplateType {
  id: string;
  name: string;
  description?: string;
  templatePath?: string; // Optional - for backward compatibility with file-based templates
  content?: string; // HTML content stored in database - preferred method
  dynamicFields: DocumentTemplateField[];
  isActive: boolean;
  organizationId: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface DocumentTemplateField {
  key: string;
  label: string;
  type: 'text' | 'number' | 'date' | 'boolean' | 'select' | 'multiline' | 'client' | 'services';
  required: boolean;
  options?: string[];
  defaultValue?: any;
  placeholder?: string;
  helpText?: string;
}

export interface DocumentViewer {
  userId: string;
  viewedAt: Date;
  userRole: 'client' | 'organization';
}

export interface DocumentSignature {
  userId: string;
  userRole: 'client' | 'organization';
  signedAt?: Date;
  ipAddress?: string;
  status: DocumentSignatureStatus;
  name: string;
  title?: string;
  email?: string;
  signatureType?: 'draw' | 'type';
  signatureImageUrl?: string;
  typedName?: string;
}

export enum DocumentSignatureStatus {
  PENDING = 'pending',
  SIGNED = 'signed',
  REJECTED = 'rejected'
}

export enum DocumentStatus {
  DRAFT = 'draft',
  PENDING_SIGNATURES = 'pending_signatures',
  COMPLETED = 'completed',
  EXPIRED = 'expired',
  CANCELLED = 'cancelled'
}

export interface DocumentTag {
  id: string;
  name: string;
  color: string;
  description?: string;
  createdAt: Date;
  updatedAt: Date;
}

export interface DocumentMetadata {
  createdBy: string;
  lastModifiedBy: string;
  createdAt: Date;
  updatedAt: Date;
  expiresAt?: Date;
  version: number;
}
